import IconSocialFacebook from "@assets/images/icons/socials/Facebook-1.svg"
import IconSocialInstagram from "@assets/images/icons/socials/Instagram.svg"
import IconSocialLinkedin from "@assets/images/icons/socials/Linkedin.svg"
import IconSocialPinterest from "@assets/images/icons/socials/Pinterest.svg"
import IconSocialTwitter from "@assets/images/icons/socials/Twitter-1.svg"
import IconSocialYoutube from "@assets/images/icons/socials/Youtube-1.svg"
import IconSocialSnapchat from "@assets/images/icons/socials/Icon-Snapchat-In-circle-PNG.png"
import IconSocialTiktok from "@assets/images/icons/socials/Tiktok-Social-Logo.png"

export const Assets = {
    IconSocialFacebook
    , IconSocialInstagram
    , IconSocialLinkedin
    , IconSocialPinterest
    , IconSocialTwitter
    , IconSocialYoutube
    , IconSocialSnapchat
    , IconSocialTiktok
}